// Required by aws-amplify and @microsoft/signalr which expect a Node.js-like global object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window;
